// @ts-check
// Canvas somente leitura (spec 2.0.0, fluxos.md seções 20.3 e 20.13; contrato 09 de fluxos, seção 17): a prévia de um
// modelo na galeria (zoom de 60%) e o "Caminho do fluxo" das estatísticas, com os contadores do período clicáveis. É o
// mesmo canvas do editor, sem inserir, excluir nem o botão de ações; o teclado anda pela árvore do mesmo jeito.
import { html } from 'htm/preact';
import { useMemo, useState } from 'preact/hooks';
import { FLOW_ENTRY_FOCUS, flowStepNumbers } from '../../lib/flow-canvas-keyboard.js';
import { FLOW_DEFAULT_ZOOM } from '../../lib/flow-zoom.js';
import { FlowCanvas } from './flow-canvas.js';
import { t } from '../../i18n/index.js';

/**
 * @typedef {import('../../../../shared/flows/flow-definition.js').FlowDefinition} FlowDefinition
 * @typedef {import('../../../../shared/flows/flow-summary.js').FlowSummaryLookups} FlowSummaryLookups
 * @typedef {import('../../data/flows.js').FlowNodeCounts} FlowNodeCounts
 */

/**
 * @param {{ definition: FlowDefinition, lookups: FlowSummaryLookups, ariaLabel: string, initialZoom?: number, counts?: FlowNodeCounts | null,
 *   flowId?: string | null, period?: { from?: string | null, to?: string | null }, className?: string }} props
 */
export function FlowMiniCanvas({ definition, lookups, ariaLabel, initialZoom = 0.6, counts = null, flowId = null, period = {}, className = '' }) {
  const [zoom, setZoom] = useState(initialZoom || FLOW_DEFAULT_ZOOM);
  const [focusTarget, setFocusTarget] = useState(FLOW_ENTRY_FOCUS);
  const stepNumbers = useMemo(() => flowStepNumbers(definition), [definition]);
  const showCounts = Boolean(counts && flowId);
  return html`<${FlowCanvas} className=${`flow-mini-canvas ${className}`} definition=${definition} isReadOnly=${true} ariaLabel=${ariaLabel}
    tree=${{
      lookups, problemsByNode: new Map(), stepNumbers, selectedNodeId: null, counts, showCounts, flowId, isReadOnly: true, activePointKey: null,
      isDragging: false, isPulsing: false, period, insertDisabledReason: () => null,
    }}
    entryProblems=${[]} entryCounts=${counts?.entry ? { entered: counts.entry.entered, inFlow: counts.entry.inFlow } : null}
    focusTarget=${focusTarget} onFocusTarget=${setFocusTarget} zoom=${zoom} onZoom=${setZoom} showCounts=${showCounts} canShowCounts=${false}
    onToggleCounts=${() => undefined} announcement="" centerSignal=${0} />`;
}

/** Rótulo da árvore de uma prévia. @param {string} name */
export const miniCanvasLabel = (name) => t('flows.canvas.treeLabel', { name });
